import useGenre from '@/hooks/useGenre';
import usePlatform from '@/hooks/usePlatform';
import useGameStore from '@/store';
import { useT } from '@/i18n/useLanguage';
import { Box, Text } from '@chakra-ui/react';
import { Heading } from '@chakra-ui/react/typography';

const GameHeading = () => {
	const genreId = useGameStore((s) => s.gameQuery.genreId);
	const platformId = useGameStore((s) => s.gameQuery.platformId);
	const searchText = useGameStore((s) => s.gameQuery.search);
	const t = useT();

	const genre = useGenre(genreId);
	const platform = usePlatform(platformId);

	let title = t('allGames');
	if (searchText) title = `${t('resultsFor')} “${searchText}”`;
	else if (platform?.name || genre?.name) {
		title = [platform?.name, genre?.name, t('games')].filter(Boolean).join(' ');
	}

	return (
		<Box>
			<Text
				fontSize="xs"
				fontWeight="600"
				textTransform="uppercase"
				letterSpacing="widest"
				color="brand.400"
				mb={1}
			>
				{t('discover')}
			</Text>
			<Heading
				fontWeight="800"
				fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }}
				as="h1"
				letterSpacing="tight"
				lineHeight="1.15"
			>
				{title}
			</Heading>
		</Box>
	);
};

export default GameHeading;
